import { contactSelectors, currentUserSelectors, directoryActions } from '@lifesize/nucleus';
import Logger from './logger';
import _uniqBy from 'lodash/uniqBy';
import { routes } from 'constants/Application';

export const preLoadMissingMeetingInfo = (dispatch, contact) => new Promise(resolve => {
  if (contact && (contact.moderatorID || contact.lecturerID)) {
    dispatch((dispatch, getState) => {
      const state = getState();
      const contactLookup = contactSelectors.getContactByUuidGenerator(state);
      const moderator = contactLookup(contact.moderatorID) || {};
      const lecturer = getContact(contact.lecturerID) || {};

      if (!moderator.name || !lecturer.name) {
        const selfUUID = currentUserSelectors.getUserUUID(state);
        const fetchUUIDs = _uniqBy([contact.uuid, contact.moderatorID, contact.lecturerID].filter(x => x && x !== selfUUID), x => x);
        if (fetchUUIDs.length) {
          Logger.info('Newly-created meeting object has missing info', contact.id);
          Logger.info('Fetching data for missing meeting objects, ids are', fetchUUIDs);
          dispatch(directoryActions.loadByUUIDs(fetchUUIDs)).then(() => resolve());
        } else {
          resolve();
        }
      } else {
        resolve();
      }
    });
  } else {
    resolve();
  }
});

export const loadMissingMeetingInfo = (dispatch, newContact) => {
  // CA-1204: Reload if contact info not present
  if (newContact && (newContact.moderatorUUID || newContact.lecturerUUID)) {
    dispatch((dispatch, getState) => {
      const state = getState();
      const contactLookup = contactSelectors.getContactByUuidGenerator(state);
      const moderator = contactLookup(newContact.moderatorUUID) || {};
      const lecturer = getContact(newContact.lecturerUUID) || {};

      if (!moderator.name || !lecturer.name) {
        const selfUUID = currentUserSelectors.getUserUUID(state);
        const fetchUUIDs = _uniqBy([newContact.uuid, newContact.moderatorUUID, newContact.lecturerUUID].filter(x => x && x !== selfUUID), x => x);
        if (fetchUUIDs.length) {
          Logger.info('Newly-created meeting object has missing info', newContact.id);
          Logger.info('Fetching data for missing meeting objects, ids are', fetchUUIDs);
          dispatch(directoryActions.loadByUUIDs(fetchUUIDs));
        }
      }
    });
  }
};

export const getContact = (state, userId, contactId) => {
  if (contactId === userId) {
    return currentUserSelectors.myInfo(state);
  }

  return contactSelectors.getContactByUuidGenerator(state)(contactId) || {};
};

const getRoute = (contact) => {
  if (contact.isMeeting) {
    return routes.meetings;
  }
  if (contact.isRoomSystem) {
    return routes.roomSystems;
  }
  return routes.contacts;
}

export const selectContact = (contact, pushRoute) => {
  pushRoute(`${getRoute(contact)}/${contact.uuid}`);
}

export const filterSearchedContactsInCall = (searchResults, participants) =>
  searchResults.filter(result => !participants.find(participant => participant.uuid === result?.contact?.uuid))
